module.exports = __webpack_public_path__ + "images/entrances-cda50b6c438fb9311b79bca81670bded.jpg";